export default {
  default: () => import("/app/layouts/default.vue").then(m => m.default || m),
  system: () => import("/app/layouts/system.vue").then(m => m.default || m)
}